import './component/AxiosCORS';
import ReactDOM from 'react-dom/client';
import './css/common.css';
import './css/reset.css';
import './css/main.bundle.css';
import './css/print.css';
import './font/pretendard.css';
import { BrowserRouter } from 'react-router-dom';

import Layout from './Layout';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <BrowserRouter>
        <Layout />
    </BrowserRouter>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
